module.exports = __webpack_public_path__ + "static/media/LegoShadowTheatreINTA0036_design_clean_v002.400d5a2a.png";